import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 3,
      name: i18n.t('tipos.metadata.fecha_factura')
    },
    {
      id: 4,
      name: i18n.t('tipos.metadata.importe_total')
    },
    {
      id: 5,
      name: i18n.t('tipos.metadata.cif_propietario')
    },
    {
      id: 6,
      name: i18n.t('tipos.metadata.num_factura')
    },
    {
      id: 7,
      name: i18n.t('tipos.metadata.num_serie_factura')
    },
    {
      id: 8,
      name: i18n.t('tipos.metadata.fecha_operacion')
    },
    {
      id: 9,
      name: i18n.t('tipos.metadata.preiodo_facturacion')
    },
    {
      id: 10,
      name: i18n.t('tipos.metadata.pago')
    },
    {
      id: 11,
      name: i18n.t('tipos.metadata.moneda')
    },
    {
      id: 12,
      name: i18n.t('tipos.metadata.envio')
    },
    {
      id: 13,
      name: i18n.t('tipos.metadata.descripcion')
    },
    {
      id: 14,
      name: i18n.t('tipos.metadata.cantidad')
    },
    {
      id: 15,
      name: i18n.t('tipos.metadata.importe_producto')
    },
    {
      id: 17,
      name: i18n.t('tipos.metadata.referencia_emisor')
    },
    {
      id: 18,
      name: i18n.t('tipos.metadata.referencia_receptor')
    },
    {
      id: 19,
      name: i18n.t('tipos.metadata.referencia_operacion')
    },
    {
      id: 20,
      name: i18n.t('tipos.metadata.referencia_expediente')
    },
    {
      id: 21,
      name: i18n.t('tipos.metadata.referencia_albaran')
    },
    {
      id: 22,
      name: i18n.t('tipos.metadata.bruto')
    },
    {
      id: 23,
      name: i18n.t('tipos.metadata.descuento')
    },
    {
      id: 24,
      name: i18n.t('tipos.metadata.cargo')
    },
    {
      id: 25,
      name: i18n.t('tipos.metadata.suplidos')
    },
    {
      id: 26,
      name: i18n.t('tipos.metadata.gastos_financieros')
    },
    {
      id: 27,
      name: i18n.t('tipos.metadata.anticipos')
    },
    {
      id: 28,
      name: i18n.t('tipos.metadata.retencion')
    },
    {
      id: 29,
      name: i18n.t('tipos.metadata.numero_pedido')
    },
    {
      id: 30,
      name: i18n.t('tipos.metadata.nombre_emisor')
    },
    {
      id: 31,
      name: i18n.t('tipos.metadata.cif_emisor')
    },
    {
      id: 32,
      name: i18n.t('tipos.metadata.nombre_receptor')
    },
    {
      id: 33,
      name: i18n.t('tipos.metadata.cif_receptor')
    },
    {
      id: 34,
      name: i18n.t('tipos.metadata.nombre_cesionario')
    },
    {
      id: 35,
      name: i18n.t('tipos.metadata.cif_cesionario')
    },
    {
      id: 36,
      name: i18n.t('tipos.metadata.numero_centro_admin')
    },
    {
      id: 37,
      name: i18n.t('tipos.metadata.clase_impuesto')
    },
    {
      id: 39,
      name: i18n.t('tipos.metadata.total_impuesto')
    },
    {
      id: 40,
      name: i18n.t('tipos.metadata.clase_retencion')
    },
    {
      id: 42,
      name: i18n.t('tipos.metadata.total_retencion')
    },
  ]
}

export function TIPOS_METADATOS (state) {
  return configHelper.getConfig(state, 'TIPOS_METADATOS', GenerateConfig)
}
